import React, { useState } from "react";
import FontStyleSelector from "./FontStyleSelector";
import { putTheme } from "../../../../shared/services/services";
import { fontStyles, themeStyles } from "../../../../shared/services/themes";
import { useUser } from "../../components/UserContext";
import { notifyError, notifySuccess } from "../../../../assets/toastService";
import useUsers from "../../hooks/useUsers";

const ProfileTheme = () => {
  const { user } = useUser();
  const { reload } = useUsers()
  const [colorTheme, setColorTheme] = useState<string>(user?.themes.backgroundColour || "Blue");
  const [fontStyle, setFontStyle] = useState<string>(user?.themes.fontFamily || "Sans-serif");

  const isActive = user?.themes.backgroundColour !== colorTheme || user?.themes.fontFamily !== fontStyle;

  const updateThemes = (Reset?: boolean) => {
    const themes = {
      backgroundColor: Reset ? "Blue" : colorTheme,
      fontFamily: Reset ? "Sans-serif" : fontStyle,
    };

    putTheme(themes)
      .then(() => {
        notifySuccess(Reset ? "Theme reset successfully" : "Theme updated successfully");
        reload()
        if (Reset) {
          setColorTheme("Blue");
          setFontStyle("Sans-serif");
        }
      })
      .catch((error) => {
        console.error(error);
        notifyError(error);
      });
  };

  const reSetButton = user?.themes.backgroundColour === "Blue" && user?.themes.fontFamily === "Sans-serif";

  const colorSet = themeStyles[colorTheme as keyof typeof themeStyles] || themeStyles["Blue"];

  return (
    <div className='w-full h-full overflow-auto p-4 flex justify-center'>
      {/* Card */}
      <div className='w-full max-w-2xl border border-blue-100 shadow-xl rounded-2xl p-6 bg-white h-fit'>
        {/* Title */}
        <div className='text-center mb-6'>
          <h1 className='text-3xl font-semibold'>Profile Theme Settings</h1>
        </div>

        {/* Font Selector */}
        <FontStyleSelector fontStyle={fontStyle} setFontStyle={setFontStyle} />

        {/* Theme Colors */}
        <h1 className='text-xl font-semibold py-4'>Select Theme Color</h1>
        <div className='grid grid-cols-2 md:grid-cols-3 gap-4 my-6'>
          {Object.keys(themeStyles).map((themeOption) => (
            <button
              key={themeOption}
              className={`p-3 rounded-lg font-semibold transition shadow ${colorTheme === themeOption ? "scale-105 ring-2 ring-black" : "opacity-90"
                } ${themeStyles[themeOption]}`}
              onClick={() => setColorTheme(themeOption)}
            >
              {themeOption}
            </button>
          ))}
        </div>

        {/* Preview */}
        <div className='text-center border-t pt-4'>
          <h2 className='text-lg font-semibold mb-2'>Preview</h2>

          <div className={`w-full py-4 rounded-lg text-xl border shadow-inner ${colorSet} ${fontStyles[fontStyle]}`}>{fontStyle}</div>

          {/* Buttons */}
          <div className='flex justify-center gap-4 mt-6 flex-wrap'>
            <button
              onClick={() => updateThemes(true)}
              className={`px-4 py-2 rounded-full text-white ${reSetButton ? "bg-blue-400 cursor-not-allowed" : themeStyles["Blue"]}`}
              disabled={reSetButton}
            >
              Reset Theme
            </button>

            <button
              onClick={() => updateThemes()}
              className={`px-4 py-2 rounded-full ${isActive ? `${colorSet} cursor-pointer` : "bg-gray-300 cursor-not-allowed"}`}
              disabled={!isActive}
            >
              Theme Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileTheme;
